import { axiosAPI } from 'utils';

export default {
  translateActivity(activityId, params = {}) {
    return axiosAPI
      .post(`api/flink-make/translation/activity/${activityId}`, params)
      .then((res) => res.data)
      .catch((err) => {
        console.error(err);
        return err?.response?.data || { success: false, error: err?.message || 'Translation failed' };
      });
  },

  ensureActivityVersion(activityId, params = {}) {
    return axiosAPI
      .post(`api/flink-make/translation/activity/${activityId}/ensure-version`, params)
      .then((res) => res.data)
      .catch((err) => {
        console.error(err);
        return err?.response?.data || { success: false, error: err?.message || 'Activity language version setup failed' };
      });
  },

  translateWordAg(groupId, params = {}) {
    return axiosAPI
      .post(`api/flink-make/translation/word-ag/${groupId}`, params)
      .then((res) => res.data)
      .catch((err) => {
        console.error(err);
        return err?.response?.data || { success: false, error: err?.message || 'Word AG translation failed' };
      });
  },

  addActivityAudio(activityId, params = {}) {
    return axiosAPI
      .post(`api/flink-make/translation/activity/${activityId}/audio`, params)
      .then((res) => res.data)
      .catch((err) => {
        console.error(err);
        return err?.response?.data || { success: false, error: err?.message || 'Activity audio generation failed' };
      });
  },

  scanActivityHaitianAudio(activityId, params = {}) {
    return axiosAPI
      .post(`api/flink-make/translation/activity/${activityId}/haitian-audio/scan`, params)
      .then((res) => res.data)
      .catch((err) => {
        console.error(err);
        return err?.response?.data || { success: false, error: err?.message || 'Haitian activity audio scan failed' };
      });
  },

  scanActivityHaitianAudioReadonly(activityId, params = {}) {
    return axiosAPI
      .post(`api/flink-make/translation/activity/${activityId}/haitian-audio/scan-readonly`, params)
      .then((res) => res.data)
      .catch((err) => {
        console.error(err);
        return err?.response?.data || { success: false, error: err?.message || 'Haitian activity read-only audio scan failed' };
      });
  },

  saveActivityHaitianAudioReference(activityId, params = {}) {
    return axiosAPI
      .post(`api/flink-make/translation/activity/${activityId}/haitian-audio/reference`, params)
      .then((res) => res.data)
      .catch((err) => {
        console.error(err);
        return err?.response?.data || { success: false, error: err?.message || 'Haitian activity audio reference save failed' };
      });
  },

  addWordAgAudio(groupId, params = {}) {
    return axiosAPI
      .post(`api/flink-make/translation/word-ag/${groupId}/audio`, params)
      .then((res) => res.data)
      .catch((err) => {
        console.error(err);
        return err?.response?.data || { success: false, error: err?.message || 'Word AG audio generation failed' };
      });
  },

};
